<template>
    <div class="blueBg">
        <div class="inner">
            <h3>{{ $t('title.terms') }}</h3>
            <div class="textBox">
                <div v-if="display && isLogged && member_type === 1200 || 
                    display && isLogged && member_type === 1210 ||
                    display && isLogged && member_type === 1220 ||
                    display && isLogged && member_type === 4000">
                    <!-- article - 1 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article1.title') }}</p>
                    <p>{{ $t('outline.forcing.article1.text') }}</p>

                    <!-- article - 2 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article2.title') }}</p>
                    <p>{{ $t('outline.forcing.article2.text') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article2.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article2.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article2.point3') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article2.point4') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article2.point5') }}</p>

                    <!-- article - 3 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article3.title') }}</p>
                    <p>{{ $t('outline.forcing.article3.text') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article3.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article3.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article3.point3') }}</p>
                    
                    <!-- article - 4 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article4.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article4.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article4.point2') }}</p>
                
                    <!-- article - 5 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article5.title') }}</p>
                    <p>{{ $t('outline.forcing.article5.text') }}</p>
                    
                    <!-- article - 6 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article6.title') }}</p>
                    <p>{{ $t('outline.forcing.article6.text') }}</p>
                
                    <!-- article - 7 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article7.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article7.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article7.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article7.point3') }}</p>
                
                    <!-- article - 8 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article8.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article8.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article8.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article8.point3') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article8.point4') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article8.point5') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article8.point6') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article8.point7') }}</p>
                    
                    <!-- article - 9 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article9.title') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.forcing.article9.point1') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article9.point1_1') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article9.point1_2') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article9.point1_3') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article9.point1_4') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.forcing.article9.point2') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.forcing.article9.point3') }}</p>
                
                    <!-- article - 10 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article10.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article10.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article10.point2') }}</p>
                
                    <!-- article - 11 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article11.title') }}</p>
                    <p>{{ $t('outline.forcing.article11.text') }}</p>
                
                    <!-- article - 12 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article12.title') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.forcing.article12.point1') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article12.point1_1') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article12.point1_2') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article12.point1_3') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article12.point1_4') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.forcing.article12.point2') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.forcing.article12.point3') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.forcing.article12.point4') }}</p>

                    <!-- article - 13 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article13.title') }}</p>
                    <p>{{ $t('outline.forcing.article13.text') }}</p>
                
                    <!-- article - 14 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article14.title') }}</p>
                    <p>{{ $t('outline.forcing.article14.text') }}</p>
                
                    <!-- article - 15 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article15.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article15.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article15.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article15.point3') }}</p>

                    <!-- article - 16 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article16.title') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.forcing.article16.point1') }}</p>
                    <p class="p-0 pl-4 padding" v-if="$i18n.te('outline.forcing.article16.point1_1')">{{ $t('outline.forcing.article16.point1_1') }}</p>
                    <p class="p-0 pl-4 padding" v-if="$i18n.te('outline.forcing.article16.point1_2')">{{ $t('outline.forcing.article16.point1_2') }}</p>
                    <p class="p-0 pl-4 padding" v-if="$i18n.te('outline.forcing.article16.point1_3')">{{ $t('outline.forcing.article16.point1_3') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.forcing.article16.point2') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article16.point2_1') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article16.point2_2') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article16.point2_3') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article16.point2_4') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.forcing.article16.point2_5') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.forcing.article16.point3') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.forcing.article16.point4') }}</p>
                
                    <!-- article - 17 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article17.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article17.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article17.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article17.point3') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article17.point4') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article17.point5') }}</p>
                
                    <!-- article - 18 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article18.title') }}</p>
                    <p>{{ $t('outline.forcing.article18.text') }}</p>

                    <!-- article - 19 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article19.title') }}</p>
                    <p>{{ $t('outline.forcing.article19.text') }}</p>

                    <!-- article - 20 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article20.title') }}</p>
                    <p>{{ $t('outline.forcing.article20.text') }}</p>

                    <!-- article - 21 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article21.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article21.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article21.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article21.point3') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article21.point4') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article21.point5') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article21.point6') }}</p>

                    <!-- article - 22 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article22.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article22.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article22.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article22.point3') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article22.point4') }}</p>

                    <!-- article - 23 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article23.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article23.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article23.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article23.point3') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article23.point4') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article23.point5') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article23.point6') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article23.point7') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article23.point8') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article23.point9') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article23.point10') }}</p>
                    
                    <!-- article - 24 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article24.title') }}</p>
                    <p>{{ $t('outline.forcing.article24.text') }}</p>

                    <!-- article - 25 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article25.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article25.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article25.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article25.point3') }}</p>

                    <!-- article - 26 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article26.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article26.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.forcing.article26.point2') }}</p>

                    <!-- article - 27 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article27.title') }}</p>
                    <p>{{ $t('outline.forcing.article27.text') }}</p>

                    <!-- article - 28 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.forcing.article28.title') }}</p>
                    <p>{{ $t('outline.forcing.article28.text') }}</p>

                    <!-- enactment date, revision date -->
                    <p class="mt-5">
                        {{ $t('outline.enactment_date', {
                            y: 2019,
                            m: 12,
                            M: 'December',
                            d: 17,
                        }) }}<br>
                        {{ $t('outline.revision_date', {
                            y: 2025,
                            m: 10,
                            M: 'October',
                            d: 1,
                    }) }}
                    </p>
                </div>

                <div v-else>
                    <!-- article - 1 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article1.title') }}</p>
                    <p>{{ $t('outline.general.article1.text') }}</p>
                    
                    <!-- article - 2 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article2.title') }}</p>
                    <p>{{ $t('outline.general.article2.text') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article2.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article2.point2') }}</p>
                    
                    <!-- article - 3 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article3.title') }}</p>
                    <p>{{ $t('outline.general.article3.text') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article3.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article3.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article3.point3') }}</p>

                    <!-- article - 4 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article4.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article4.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article4.point2') }}</p>

                    <!-- article - 5 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article5.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article5.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article5.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article5.point3') }}</p>
                
                    <!-- article - 6 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article6.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article6.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article6.point2') }}</p>
                
                    <!-- article - 7 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article7.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article7.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article7.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article7.point3') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article7.point4') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article7.point5') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article7.point6') }}</p>
                
                    <!-- article - 8 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article8.title') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.general.article8.point1') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article8.point1_1') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article8.point1_2') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article8.point1_3') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article8.point1_4') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.general.article8.point2') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.general.article8.point3') }}</p>
                
                    <!-- article - 9 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article9.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article9.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article9.point2') }}</p>
                
                    <!-- article - 10 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article10.title') }}</p>
                    <p>{{ $t('outline.general.article10.text') }}</p>

                    <!-- article - 11 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article11.title') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.general.article11.point1') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article11.point1_1') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article11.point1_2') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article11.point1_3') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article11.point1_4') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.general.article11.point2') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.general.article11.point3') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.general.article11.point4') }}</p>

                    <!-- article - 12 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article12.title') }}</p>
                    <p>{{ $t('outline.general.article12.text') }}</p>

                    <!-- article - 13 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article13.title') }}</p>
                    <p>{{ $t('outline.general.article13.text') }}</p>

                    <!-- article - 14 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article14.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article14.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article14.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article14.point3') }}</p>

                    <!-- article - 15 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article15.title') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.general.article15.point1') }}</p>
                    <p class="p-0 pl-4 padding" v-if="$i18n.te('outline.general.article15.point1_1')">{{ $t('outline.general.article15.point1_1') }}</p>
                    <p class="p-0 pl-4 padding" v-if="$i18n.te('outline.general.article15.point1_2')">{{ $t('outline.general.article15.point1_2') }}</p>
                    <p class="p-0 pl-4 padding" v-if="$i18n.te('outline.general.article15.point1_3')">{{ $t('outline.general.article15.point1_3') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.general.article15.point2') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article15.point2_1') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article15.point2_2') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article15.point2_3') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article15.point2_4') }}</p>
                    <p class="p-0 pl-4 padding">{{ $t('outline.general.article15.point2_5') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.general.article15.point3') }}</p>
                    <p class="p-0 pl-4 num"    >{{ $t('outline.general.article15.point4') }}</p>

                    <!-- article - 16 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article16.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article16.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article16.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article16.point3') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article16.point4') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article16.point5') }}</p>

                    <!-- article - 17 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article17.title') }}</p>
                    <p>{{ $t('outline.general.article17.text') }}</p>

                    <!-- article - 18 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article18.title') }}</p>
                    <p>{{ $t('outline.general.article18.text') }}</p>

                    <!-- article - 19 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article19.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article19.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article19.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article19.point3') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article19.point4') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article19.point5') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article19.point6') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article19.point7') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article19.point8') }}</p>

                    <!-- article - 20 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article20.title') }}</p>
                    <p>{{ $t('outline.general.article20.text') }}</p>

                    <!-- article - 21 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article21.title') }}</p>
                    <p>{{ $t('outline.general.article21.text') }}</p>

                    <!-- article - 22 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article22.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article22.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article22.point2') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article22.point3') }}</p>

                    <!-- article - 23 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article23.title') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article23.point1') }}</p>
                    <p class="p-0 pl-4 num">{{ $t('outline.general.article23.point2') }}</p>

                    <!-- article - 24 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article24.title') }}</p>
                    <p>{{ $t('outline.general.article24.text') }}</p>
                    
                    <!-- article - 25 -->
                    <p class="mt-4 font-weight-bold">{{ $t('outline.general.article25.title') }}</p>
                    <p>{{ $t('outline.general.article25.text') }}</p>

                    <!-- enactment date, revision date -->
                    <p class="mt-5">
                        {{ $t('outline.enactment_date', {
                            y: 2020,
                            m: 10,
                            M: 'October',
                            d: 1,
                        }) }}<br>
                        {{ $t('outline.revision_date', {
                            y: 2025,
                            m: 10,
                            M: 'October',
                            d: 1,
                    }) }}
                    </p>
                 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AuthUtil from '../../utils/AuthUtil';
    import UserService from "../../services/UserService";

    export default {
        name: 'outline',

        components: {
        },

        data(){
          return {
              isLogged: false,
              isChild: false,
              member_type: '',
              display: false
          }
        },

        mounted() {
            this.isLogged = AuthUtil.isAuth();

            if (this.isLogged) {
                this.fetchUserFrontendData();
            }
        },
        methods: {
            async fetchUserFrontendData() {
                const data = (await UserService.getUserFrontendData()).data;
                this.member_type = data.member_type_id;
                this.display = true;
            }
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 991px) {
        .pl-4, .px-4 {
            padding-left: 1rem !important;
        }
    }
</style>